module.exports = __webpack_public_path__ + "static/media/partner12.7580c234.png";